// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_2E2bF","listWrap":"index_listWrap_3QstN"};